/**
 *
 * @param key The key of the env variable
 * @param valueObject window or global object
 * @param defaultValue The default value of the env variable
 * @returns The value of the runtime env variable
 */
export function getEsbuildRuntimeEnvVar(key: string, valueObject?: any, defaultValue?: any): any {
  if (!valueObject) {
    throw new Error('window or global is not defined');
  }

  if (!valueObject.buildEnv.USE_SERVER_VARS) {
    return defaultValue;
  }

  if (!valueObject.runtimeEnv) {
    throw new Error('window.runtimeEnv or global.runtimeEnv is not defined. Have you run inject-env script ?');
  }

  if (!valueObject.runtimeEnv[key]) {
    console.warn(
      `window.runtimeEnv['${key}'] or global.runtimeEnv['${key}'] is undefined. Provide it in your helm chart & add the key to the variable injection whitelist.`
    );
  }

  return valueObject.runtimeEnv[key];
}

/**
 *
 * @param key The key of the env variable
 * @param valueObject window or global object
 * @param defaultValue The default value of the env variable
 * @returns The value of the build time env variable
 */
export function getEsbuildBuildEnvVar(key: string, valueObject?: any, defaultValue?: any): any {
  if (!valueObject) {
    throw new Error('window or global is not defined');
  }

  if (!valueObject.buildEnv.USE_SERVER_VARS) {
    return defaultValue;
  }

  if (!valueObject.buildEnv[key]) {
    throw new Error(`${key} variable has not been defined in your webpack build configuration.`);
  }

  return valueObject.buildEnv[key];
}
